import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "search-autocomplete-root" }
const _hoisted_2 = { class: "search-input-wrapper" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = ["data-bs-title"]
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = {
  key: 0,
  class: "search-loading"
}
const _hoisted_7 = {
  key: 1,
  class: "search-error"
}
const _hoisted_8 = {
  key: 0,
  class: "search-group"
}
const _hoisted_9 = { class: "search-group-label" }
const _hoisted_10 = ["id", "href", "onMouseenter", "onClick"]
const _hoisted_11 = { class: "search-item-content" }
const _hoisted_12 = { class: "search-item-name" }
const _hoisted_13 = {
  key: 0,
  class: "search-item-preview"
}
const _hoisted_14 = { class: "search-item-badges" }
const _hoisted_15 = { class: "badge badge-type" }
const _hoisted_16 = {
  key: 1,
  class: "badge badge-book"
}
const _hoisted_17 = {
  key: 2,
  class: "badge badge-time"
}
const _hoisted_18 = {
  key: 1,
  class: "search-group"
}
const _hoisted_19 = { class: "search-group-label" }
const _hoisted_20 = ["id", "onMouseenter", "onClick"]
const _hoisted_21 = { class: "search-item-name" }
const _hoisted_22 = { class: "search-hint" }
const _hoisted_23 = {
  key: 3,
  class: "search-empty"
}
const _hoisted_24 = { class: "search-group-label" }
const _hoisted_25 = ["id", "href", "onMouseenter", "onClick"]
const _hoisted_26 = { class: "search-item-content" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 0,
  class: "search-item-preview"
}
const _hoisted_29 = { class: "search-item-badges" }
const _hoisted_30 = { class: "badge badge-type" }
const _hoisted_31 = {
  key: 1,
  class: "badge badge-book"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa-solid fa-magnifying-glass search-icon" }, null, -1 /* CACHED */)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.query) = $event)),
        type: "text",
        placeholder: $props.placeholder,
        autocomplete: "off",
        spellcheck: "false",
        onInput: _cache[1] || (_cache[1] = (...args) => ($setup.scheduleSearch && $setup.scheduleSearch(...args))),
        onKeydown: _cache[2] || (_cache[2] = (...args) => ($setup.onKeydown && $setup.onKeydown(...args))),
        onFocus: _cache[3] || (_cache[3] = (...args) => ($setup.onFocus && $setup.onFocus(...args))),
        onBlur: _cache[4] || (_cache[4] = (...args) => ($setup.onBlur && $setup.onBlur(...args)))
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3), [
        [_vModelText, $setup.query]
      ]),
      ($props.showShortcut)
        ? (_openBlock(), _createElementBlock("kbd", {
            key: 0,
            class: "search-shortcut",
            "data-bs-toggle": "tooltip",
            "data-bs-title": $setup.label('shortcutHint', 'Press / to focus search')
          }, "/", 8 /* PROPS */, _hoisted_4))
        : _createCommentVNode("v-if", true)
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "search-results",
      role: "listbox",
      "aria-label": $setup.label('resultsLabel', 'Search results')
    }, [
      ($setup.isLoading || $setup.isLoadingRecent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.label("searching", "Searching...")), 1 /* TEXT */))
        : ($setup.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.errorMessage), 1 /* TEXT */))
          : ($setup.showEmptyState)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                ($setup.recentItems.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString($setup.label("recentItems", "Recently Viewed")), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.recentItems, (item, itemIndex) => {
                        return (_openBlock(), _createElementBlock("a", {
                          id: $setup.itemDomId($setup.recentItemIndex(itemIndex)),
                          key: `recent-${item.id}`,
                          href: $props.adminMode ? '#' : item.url,
                          class: _normalizeClass(["search-item search-recent-item", { selected: $setup.selectedIndex === $setup.recentItemIndex(itemIndex) }]),
                          onMousedown: $setup.onItemMouseDown,
                          onMouseenter: $event => ($setup.selectItem($setup.recentItemIndex(itemIndex))),
                          onClick: _withModifiers($event => ($setup.handleItemClick(item)), ["prevent"])
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(['fa-solid', item.icon || 'fa-file', 'search-item-icon'])
                          }, null, 2 /* CLASS */),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(item.name), 1 /* TEXT */),
                            (item.preview)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.preview), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            (item.status_label)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass(["badge badge-status", `badge-status-${item.status}`])
                                }, _toDisplayString(item.status_label), 3 /* TEXT, CLASS */))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(item.type_label || item.type), 1 /* TEXT */),
                            (item.book)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.book), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            (item.viewed_at)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString($setup.formatRelativeTime(item.viewed_at)), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_10))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                ($setup.recentSearches.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString($setup.label("recent", "Recent Searches")), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.recentSearches, (term, termIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          id: $setup.itemDomId($setup.recentSearchIndex(termIndex)),
                          key: `term-${term}`,
                          class: _normalizeClass(["search-item search-recent", { selected: $setup.selectedIndex === $setup.recentSearchIndex(termIndex) }]),
                          onMousedown: $setup.onItemMouseDown,
                          onMouseenter: $event => ($setup.selectItem($setup.recentSearchIndex(termIndex))),
                          onClick: $event => ($setup.useRecentSearch(term))
                        }, [
                          _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fa-solid fa-clock-rotate-left search-item-icon" }, null, -1 /* CACHED */)),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(term), 1 /* TEXT */)
                        ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_20))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_22, _toDisplayString($setup.label("startTyping", "Start typing to search...")), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : ($setup.showEmpty)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString($setup.label("noResults", "No results").replace("%{query}", $setup.query.trim())), 1 /* TEXT */))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList($setup.groupedEntries(), ([type, items], groupIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: type,
                    class: "search-group"
                  }, [
                    _createElementVNode("div", _hoisted_24, _toDisplayString(items[0].type_label || type), 1 /* TEXT */),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item, itemIndex) => {
                      return (_openBlock(), _createElementBlock("a", {
                        id: $setup.itemDomId($setup.resolveGlobalItemIndex(groupIndex, itemIndex)),
                        key: item.id,
                        href: $props.adminMode ? '#' : item.url,
                        class: _normalizeClass(["search-item", { selected: $setup.selectedIndex === $setup.resolveGlobalItemIndex(groupIndex, itemIndex) }]),
                        onMousedown: $setup.onItemMouseDown,
                        onMouseenter: $event => ($setup.selectItem($setup.resolveGlobalItemIndex(groupIndex, itemIndex))),
                        onClick: _withModifiers($event => ($setup.handleItemClick(item)), ["prevent"])
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(['fa-solid', item.icon || 'fa-file', 'search-item-icon'])
                        }, null, 2 /* CLASS */),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("span", {
                            class: "search-item-name",
                            innerHTML: $setup.highlight(item.name, $setup.query.trim())
                          }, null, 8 /* PROPS */, _hoisted_27),
                          (item.preview)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(item.preview), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          (item.status_label)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["badge badge-status", `badge-status-${item.status}`])
                              }, _toDisplayString(item.status_label), 3 /* TEXT, CLASS */))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("span", _hoisted_30, _toDisplayString(item.type_label || item.type), 1 /* TEXT */),
                          (item.book)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(item.book), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ])
                      ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_25))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
    ], 8 /* PROPS */, _hoisted_5), [
      [_vShow, $setup.showDropdown]
    ])
  ]))
}